import { render, staticRenderFns } from "./OrderAbgelaufenModal.vue?vue&type=template&id=62c67a1b&"
import script from "./OrderAbgelaufenModal.vue?vue&type=script&lang=js&"
export * from "./OrderAbgelaufenModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports